import styled from 'styled-components';
import React, { FC } from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import Link from '../LocalizedLink';

import { flexCenter, flexColumn, flexRow, media } from '../../styles/helpers';

const laptopStyles = media.laptop`
  ${flexRow};
  flex-wrap: wrap;
  gap: clamp(14px, 1.6vw, 24px);
  a {
    font-size: 16px;
  }

  nav {
    margin-right: auto!important;
  }
`;

const Wrapper = styled.nav`
  ${flexColumn};
  ${flexCenter};
  gap: 15px;

  a {
    font-size: 18px;
    transition: color 180ms ease;
    &:hover {
      color: var(--color-accent);
    }
  }

  ${laptopStyles};
`;
//
const LINKS = [
  {
    name: 'MENU.SHOP_MENU',
    route: '/shop',
  },
  {
    name: 'MENU.BLOG_MENU',
    route: '/blog',
  },
  {
    name: 'MENU.CONTACT_MENU',
    route: '/contact-us',
  },
  {
    name: 'MENU.REVIEWS_MENU',
    route: '/reviews',
  },
  {
    name: 'FAQ',
    route: '/faq',
  },
];

const Navigation: FC = () => {
  const { t } = useI18next(['common']);

  return (
    <Wrapper>
      {LINKS.map((l) => (
        <Link key={l.name} to={l.route}>
          {t(l.name)}
        </Link>
      ))}
    </Wrapper>
  );
};

export default Navigation;
